import { cameraPos1, cameraPos2, SCENE_OBJ_NAMES } from "./constants";
import { sceneObjects} from "./index";
import { cameraPositionAnimation } from "./camera";
import { spin } from "./spin";
import { getRandomRouletteNumber } from "./utils";

export const addEventListeners = () => {
  window.addEventListener("keydown", (e) => {
    const camera = sceneObjects.get(SCENE_OBJ_NAMES.camera);
    if (e.key === " ") {
      console.log("Camera Position:", camera.position);
      console.log("Camera Rotation:", camera.rotation);
    } else if (e.key === "1") {
      cameraPositionAnimation(camera, cameraPos1);
    } else if (e.key === "2") {
      cameraPositionAnimation(camera, cameraPos2);
    }else if(e.key === "Enter"){
      spin({num: getRandomRouletteNumber()});
    }
  })
}
